import { useState, useCallback, useEffect, useRef } from "react";

function useOutsideClick() {
	const [isOpen, setIsOpen] = useState(false);
	const ref = useRef<HTMLDivElement>(null);
	const toggleRef = useRef<HTMLDivElement>(null);

	const toggleDropdown = useCallback(() => {
		setIsOpen((prev) => !prev);
	}, []);

	const openDropDown = useCallback(() => {
		setIsOpen(true);
	}, []);

	const closeDropdown = useCallback(() => {
		setIsOpen(false);
	}, []);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			const target = event.target as Node;
			const isOutsideRef = ref.current && !ref.current.contains(target);
			const isOutsideToggle =
				!toggleRef.current || !toggleRef.current.contains(target);

			if (isOutsideRef && isOutsideToggle) {
				event.stopPropagation();
				closeDropdown();
			}
		}

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [closeDropdown]);

	return [
		isOpen,
		toggleDropdown,
		closeDropdown,
		ref,
		openDropDown,
		toggleRef,
	] as const;
}

export default useOutsideClick;
